import content from "./content";
import site from "./site";

export default {
  content,
  site,
};
